<template>
  <div class="formulate-input">
    <div class="formulate-input-label">Foto</div>
    <div class="_activity-attachment-wrapper">
      <div
        :role="attachment ? 'img' : 'button'"
        :class="{
          '_activity-attachment': true,
          _empty: !attachment,
        }"
        v-for="(attachment, idx) in [
          ...attachments,
          ...Array(maxAttachment - attachments.length).fill(false),
        ]"
        :key="attachment?.id"
      >
        <template v-if="attachment?.url">
          <img :src="attachment.url" />
        </template>
        <template v-else-if="localAttachment?.src && idx === attachments.length">
          <div class="__attachment-wrapper">
            <b-skeleton class="__skeleton" />
            <img :src="localAttachment.src" />
          </div>
        </template>
        <template v-else>
          <div @click="handleLoadImage" class="_no-image">
            <i class="icon-fill_image"></i>
          </div>
        </template>
      </div>
    </div>

    <input type="file" accept="image/*" @change="handleFileChanged" ref="fileInputRef" hidden />
  </div>
</template>

<script>
import toastErrors from '../lib/constants/toast-errors'
import * as FleetTaskActivity from '@/services/rest-api/lib/fleet-task/activity'

export default {
  props: {
    activity: {
      type: Object,
      required: true,
    },
    fleetTaskId: {
      type: String,
      required: true,
    },
    pointId: {
      type: String,
      required: true,
    },
    attachments: {},
    isLoading: {},
  },
  emits: ['refetch-attachments'],
  data() {
    return {
      maxAttachment: 5,
      localAttachment: null,
    }
  },
  methods: {
    handleLoadImage() {
      if (this.isLoading) {
        this.$mcToast.warning('Mohon Tunggu')
        return
      }

      this.$refs.fileInputRef.click()
    },
    async handleFileChanged(e) {
      const MAX_FILE_SIZE = 1024 * 1024 * 2 // 2MB
      const [file] = e.target.files
      if (!file) return

      if (file.size > MAX_FILE_SIZE) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: 'Gagal unggah foto. Ukuran foto melebihi batas ketentuan <strong>(2 MB)</strong>',
              },
            ],
          },
        })

        e.target.value = ''
        return
      }

      this.localAttachment = {
        src: URL.createObjectURL(file),
      }

      this.$emit('update:isLoading', true)
      const res = await FleetTaskActivity.uploadAttachment(
        this.fleetTaskId,
        this.pointId,
        this.activity.id,
        {
          type: 'photo',
          file,
        }
      )

      if (res.errors) {
        this.$mcToast.error(toastErrors['attachment/failed-to-save'])
        return
      }

      e.target.value = ''
      this.localAttachment = null
      this.$emit('refetch-attachments')
      this.$emit('update:isLoading', false)
    },
  },
}
</script>

<style scoped lang="scss">
._activity-attachment-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

._activity-attachment {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 74px;
  aspect-ratio: 1/1;
  border: 1px solid none;
  border-radius: 4px;
  overflow: hidden;

  & ._no-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &._empty {
    border: 1px dashed #67718b;
  }

  i::before {
    font-size: 32px;
    color: #99a1b1;
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .__attachment-wrapper {
    position: relative;
    height: 100%;
    width: 100%;

    .__skeleton {
      position: absolute;
      top: 0;
      left: 0;
      transform: rotate(90deg);
      opacity: 0.5;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
